import { createSlice } from '@reduxjs/toolkit'

const criticidSlice = createSlice({
  name: 'criticid',
  initialState: { initialFilter: null },
  reducers: {
    setInitialFilter: (state, action) => {
      state.initialFilter = action.payload
    },
    clearInitialFilter: (state) => {
      state.initialFilter = null
    },
  },
})

export const { setInitialFilter, clearInitialFilter } = criticidSlice.actions
export const getInitialFilter = (state) => state.criticid.initialFilter
export default criticidSlice.reducer
